import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";

import { mstrPath } from "../../../utils/mstrBase";

import { PortalErrorMessage } from "./PortalError";

function ErrorDisplay() {
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const errorCode = searchParams.get("type");

  // eslint-disable-next-line no-console
  console.log("[ErrorDisplay] build-marker 2026-09-14, errorCode:", errorCode);

  return (
    <Box
      sx={{
        position: "relative",
        background:
          "linear-gradient(137deg, rgba(17, 81, 143, 1) 35%, rgba(25,118,210,1) 42%, rgba(16,152,226,1) 55%)",
        width: "100%",
        minHeight: "100%",
        zIndex: 98,
        flexGrow: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <Typography sx={{ color: "white", fontWeight: "bold", fontSize: "24px" }}>
        {PortalErrorMessage(errorCode)}
      </Typography>
      {errorCode !== "TIMEOUT" && (
        <Typography sx={{ color: "#f4f4f4" }}>
          Vuelva a intentarlo en unos minutos o contacte con su administrador si el problema
          persiste.
        </Typography>
      )}
      <Button
        sx={{
          marginTop: "10px",
          fontSize: "12px",
          color: "#rgba(17, 81, 143)",
          background: "white",
        }}
        onClick={() => {
          history.push(mstrPath("app"));
          history.go(0);
        }}
      >
        Pulse AquÃƒÆ’Ã‚Â­ para volver a la aplicaciÃƒÆ’Ã‚Â³n
      </Button>
    </Box>
  );
}

export default ErrorDisplay;
